<template>
  <div>
    <toolbar brandName="Paylief" subText=" Payroll Wizard"></toolbar>
    <div class="mainContainer">
      <div>
        <nav-drawer
          :title="entity_name"
          :backLinkText="backLinkText"
          :backLinkUrl="backLinkUrl"
          :items="nav_items"
          :logoUrl="logoUrl"
        ></nav-drawer>
      </div>
      <div class="navComponent">
        <keep-alive>
          <component :is="currentComponent"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Toolbar from "./shell/RunPRToolbar.vue";
import NavDrawer from "./shell/RunPRNavDrawer.vue";

/* ******************************************
  @Configs
* ******************************************/
const mapNameToComponents = {
  paygroups: () => import("./pages/paygroups/PaygroupsIntro.vue"),
  joinings: () => import("./pages/joinings/JoiningIntro.vue"),
  exits: () => import("./pages/exits/ExitIntro.vue"),
  lopsandrlops: () => import("./pages/lopsandrlops/lopsandrlopsIntro.vue"),
  variableEarnings: () =>
    import("./pages/variableearnings/variableearningsIntro.vue"),
  tds: () => import("./pages/tds/tdsIntro.vue"),
  summary: () => import("./pages/summary/summaryIntro.vue"),
  selectedEmployee: () =>
    import("./pages/selectedEmployesForPayroll/selectedEmployee/index.vue"),
  lopsandrlopForOffPayroll: () => import("./pages/selectedEmployesForPayroll/lopsandrlops/lopsandrlopsIntro.vue"),
  workBaseDays: () => import("./pages/workBaseDays/workBaseDays"),
  variableEarningsForOffPayroll: () => import("./pages/selectedEmployesForPayroll/variableearnings/variableearningsIntro.vue"),
  onsiteForoffPayroll:() => import("./pages/onsite/onsite.vue"),
  taxafterPayroll:()=> import ('./pages/taxoutsidePayroll/taxoutsidePayroll.vue'),
  arrearOverride:() => import("./pages/arrearoveride/arrearoveride.vue"),
  ScheduledEarningsandDeductions:() => import("./pages/Installments/ScheduledEarningsandDeductions.vue"),
  tdsForOffPayroll: () => import("./pages/selectedEmployesForPayroll/tds/tdsIntro.vue"),
  summaryForOffPayroll: () => import("./pages/selectedEmployesForPayroll/summary/summaryIntro.vue"),
};

const getPathForStep = (entity_index, step_name, sub_step) => {
  if (sub_step) return `/payroll/run/${entity_index}/${step_name}/${sub_step}`;
  else return `/payroll/run/${entity_index}/${step_name}`;
};
const nav_items_runPayroll = (entity_index, entityId) => {
  let array =[
  {
    type: "navitem",
    label: "Paygroups",
    status: "pending",
    path: getPathForStep(entity_index, "paygroups")
  },
  {
    type: "navitem",
    label: "Joining",
    status: "pending",
    path: getPathForStep(entity_index, "joinings")
  },
  {
    type: "navitem",
    label: "Exits",
    status: "pending",
    path: getPathForStep(entity_index, "exits")
  },
  {
    type: "navitem",
    label: "LOPs / RLOPs",
    status: "pending",
    path: getPathForStep(entity_index, "lopsandrlops")
  },
  {
    type: "navitem",
    label: "WorkDays / BaseDays",
    status: "pending",
    path: getPathForStep(entity_index, "workBaseDays"),
  },
  {
    type: "navitem",
    label: "On-Site",
    status: "pending",
    path: getPathForStep(entity_index, "onsiteForoffPayroll")
  },
  {
    type: "navitem",
    label: "Installments",
    status: "pending",
    path: getPathForStep(entity_index, "ScheduledEarningsandDeductions")
  },
  {
    type: "navitem",
    label: "Earnings & Deductions",
    status: "pending",
    path: getPathForStep(entity_index, "variableEarnings")
  },
  // {
  //   type: "navitem",
  //   label: "Arrear Overrides",
  //   status: "pending",
  //   path: getPathForStep(entity_index, "arrearOverride")
  // },
  // {
  //   type: "navitem",
  //   label: "TDS Overrides",
  //   status: "pending",
  //   path: getPathForStep(entity_index, "tds")
  // },
  {
    type: "navitem",
    label: "Tax Outside Payroll",
    status: "pending",
    path: getPathForStep(entity_index, "taxafterPayroll")
  },
  {
    type: "navitem",
    label: "Summary",
    status: "pending",
    path: getPathForStep(entity_index, "summary")
  }
  
]
const overrideAccessConfig = [
  {
    emails: [
      'asif.khan@teamlease.com',
      'sagar.shetty@teamlease.com',
      'akash.kumar@teamlease.com',
      'abhishek.reddy@teamlease.com',
      'sathishkumar.rajendiran@teamlease.com',
      'mukesh.kumar@teamlease.com',
      'rakshitha.raj@teamlease.com',
      'manjunath.hanumanthappa@teamlease.com',
      'ranjan.ranganath@teamlease.com',
      'sudarshan.puttaraju@teamlease.com'
    ],
    entities: null
  },
  {
    emails: ['gowtham.srinivasan@team-lease.co.in', 'chandru.loganathan@teamlease.com'],
    entities: ['ec495dc9-8c68-4ad7-9c5c-c7a3e876ef68', '2244bce5-9bc3-4854-aa0e-5e4cb95e5602', '9a11b241-f097-43c4-a79a-a6fa726cdd86']
  },
  {
    emails: ['bhavana.basavaraju@teamlease.com', 'abdul.nihal@teamlease.com'],
    entities: ['51c82d11-3a72-459f-8a22-7db1a74d1615', '415ab638-db6f-43e9-8a80-1aec05cd2259', 'e3a3df2d-60f4-442c-8624-a626b3778df2']
  }
]

const emailId = localStorage.getItem("loginId")
const hasOverrideAccess = overrideAccessConfig.some(config =>
  config.emails.includes(emailId) && (config.entities === null || config.entities.includes(entityId))
)

if (hasOverrideAccess) {
  array.push(
    { type: "navitem", label: "Arrear Overrides", status: "pending", path: getPathForStep(entity_index, "arrearOverride") },
    { type: "navitem", label: "TDS Overrides", status: "pending", path: getPathForStep(entity_index, "tds") }
  )
}
 return array
}


const nav_items_off_cycle_payroll = entity_index => [
  {
    type: "navitem",
    label: "Select Employee",
    status: "pending",
    path: getPathForStep(entity_index, "selectedEmployee"),
  },
  {
    type: "navitem",
    label: "LOPs / RLOPs",
    status: "pending",
    path: getPathForStep(entity_index, "lopsandrlopForOffPayroll"),
  },
  {
    type: "navitem",
    label: "Earnings & Deductions",
    status: "pending",
    path: getPathForStep(entity_index, "variableEarningsForOffPayroll"),
  },
  {
    type: "navitem",
    label: "TDS Overrides",
    status: "pending",
    path: getPathForStep(entity_index, "tdsForOffPayroll"),
  },
  {
    type: "navitem",
    label: "Summary",
    status: "pending",
    path: getPathForStep(entity_index, "summaryForOffPayroll"),
  }
];

/* ******************************************
  @Main Component
* ******************************************/
export default {
  components: {
    Toolbar,
    NavDrawer
  },
  props: ["step_name", "sub_step", "entity_index"],
  data() {
    return {
      nav_items: [],
      backLinkText: "Back to Dashboard",
      backLinkUrl: `/dashboard/${this.$route.params.entity_index}/payroll`,
      entity_name: "Lakshmi Services Pvt Ltd",
      isVisible: false,
      logoUrl: ""
    };
  },
  created() {
    if(this.$route.query.record == "offPayroll"){
      window.localStorage.setItem("payroll", 'offCycle');
    }
    if(localStorage.getItem('payroll') == 'offCycle'){
      this.nav_items = nav_items_off_cycle_payroll(this.entity_index);
    }else{
      this.nav_items = nav_items_runPayroll(this.entity_index, this.$store.getters["onboard/legal_entities/legal_entity_ID"](this.entity_index));
    }
    this.fetchAll();
    this.changeNavDrawer();
  },

  watch: {
    level: function() {
      this.changeNavDrawer();
    }
  },

  methods: {
    async fetchAll() {
      if (this.$_.isEmpty(this.entities)) {
        this.changeNavDrawer();
      }
    },
    changeNavDrawer() {
      this.entity_name = this.entities[this.entity_index]
        ? this.entities[this.entity_index].legalName
        : null;
      this.logoUrl = this.entities[this.entity_index]
        ? this.entities[this.entity_index].logoURL
        : null;

      if (this.is_org_level) {
        this.nav_items = nav_items_org;
        this.entity_name = null;
        this.backLinkUrl = null;
        this.backLinkText = null;
      } else if (this.is_entity_level) {
        this.nav_items = nav_items_entity(this.entity_index);

        this.entity_name = this.entities[this.entity_index]
          ? this.entities[this.entity_index].legalName
          : null;
        this.backLinkUrl = "/onboarding/summary";
        this.backLinkText = "All legal entities";
        this.logoUrl = this.entities[this.entity_index]
          ? this.entities[this.entity_index].logoURL
          : null;
      }
    },

    /* scroll to top navigation
         author: adithya */

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    /* finding the scrollY position
         author: adithya */

    handleScroll(event) {
      let scrolled = window.scrollY > 300;
      if (scrolled) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    }
  },

  computed: {
    ...mapState({
      entities: state => state.onboard.legal_entities.data
    }),
    is_org_level: {
      get() {
        return this.level == "org";
      }
    },
    is_entity_level: {
      get() {
        return this.level == "entity";
      }
    },

    currentComponent: function() {
      if (this.sub_step) {
        return mapNameToComponents[this.sub_step];
      } else {
        return mapNameToComponents[this.step_name];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.navComponent {
  flex: 1 1 auto;
  width: 100%;
  margin-left: 250px;
  margin-top: 65px;
}

.mainContainer {
  display: flex;
  flex-direction: row;
}
</style>
